<template>
	<div class="centerWidth">
		<section class="gaokao-content">
			<div class="my-title">家庭环境测评</div>
			<article class="testTwo-con">
				<div class="testTwo-list" v-for="(item, index) in list" :key="index">
					<p class="test-ctxt" :class="item.NotEmpty?'empty-question':''">{{item.Sort}}/{{Totla}}{{item.Title}}</p>
					<ul class="testTwo-ul">
						<li v-for="(it,ind) in item.AnswerList" :key="ind" @click="changeInput(index,ind)">
							<!-- <input :type="item.Type==1?'radio':'checkbox'" name="radio1"
								@change="changeInput(index,it)" /> -->
								<!-- 单选  Eva-aa.png-->
								<img v-if="item.Type==1" :src="it.isSelect?require('../../../image/Eva-aa.png'):require('../../../image/Eva-a.png')" />	
								<!-- 多选 login_cc.png-->	
								<img v-if="item.Type==2" :src="it.isSelect?require('../../../image/login_cc.png'):require('../../../image/login_c.png')" />
							<p>{{it.Option}}、{{it.Content}}</p>
						</li>
					</ul>
				</div>
			</article>
			<div class="test-btn"><button class="gaokao-btn" @click="goNext()">提交</button></div>
		</section>
		<!-- 5.30 -->
		<div class="ptpopupTc flexCenter" v-show="isJiaIng">
			<div class="ptpotxt">
				<div class="ptadiva" id="myChartYuan"></div>
				<p>请稍等,正在为您生成报告...</p>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				ratioTime:null,
				isJiaIng: false,
				list: [],
				id: 0,
				key: '',
				Totla: 0
			};
		},
		mounted() {
			var id = this.$route.query.id || 0;
			var key = this.$route.query.key || '';
			if (id) {
				this.id = id;
				this.key = key;
				this.GetEvaluationQuestion();
			} else {
				this.$message.error('网络错误');
				setTimeout(() => {
					this.$router.go(-1);
				}, 1000);
			}
			this.drawLineB(0);
		},
		beforeDestroy() {
			if (this.ratioTime) {
				clearTimeout(this.ratioTime);
				this.ratioTime = null;
			}
		},
		methods: {
			drawLineB(nub) {
				var that = this;
				console.log('nub', nub);
				const myChart = this.$echarts.init(document.getElementById('myChartYuan'));
				myChart.setOption({
					color: ['#feb9a7', '#3171ff00'],
					tooltip: {
						trigger: 'item',
						show: false
					},
					graphic: {
						type: 'text',
						left: 'center',
						top: 'center',
						style: {
							text: nub + '%',
							textAlign: 'center',
							fill: '#7ac8fd',
							fontSize: 24
						}
					},
					legend: {
						top: '0%',
						left: 'center'
					},
					series: [{
						type: 'pie',
						radius: ['55%', '65%'],
						avoidLabelOverlap: false,
						hoverAnimation: false,
						label: {
							show: false,
							position: 'center'
						},
						emphasis: {
							label: {
								show: true,
								fontSize: '40',
								fontWeight: 'bold'
							}
						},
						labelLine: {
							show: true
						},
						data: [{
							value: nub,
							name: ''
						}, {
							value: (100 - nub),
							name: ''
						}]
					}]
				});
				if (nub > 0 && nub < 100) {
					that.ratioTime = setTimeout(() => {
						var dd = nub;
						if (dd === 99) {
							dd = 99;
						} else if (dd > 80) {
							dd = dd + 1;
						} else if (dd > 60) {
							dd = dd + 5;
						} else {
							dd = dd + 10;
						}
						that.drawLineB(dd);
					}, 1000);
				} else {
					if (that.ratioTime) {
						clearTimeout(that.ratioTime);
						that.ratioTime = null;
					}
				}
			},
			goNext() {
				var that = this;
				var Answer = [];
				var NotEmpty = false;
				that.list = that.list.map(a => {
					a.NotEmpty = true;
					var item = {
						QuestionId: a.Id,
						Type: a.Type,
						Option: ''
					};
					var Option = [];
					a.AnswerList.map(b => {
						if (b.isSelect) {
							a.NotEmpty = false;
							Option.push(b.Option)
						}
					})
					if(Option.length>0){
						item.Option = Option.join(',');
					}
					Answer.push(item);
					if(a.NotEmpty){
						NotEmpty = true;
					}
					return a;
				});
				console.log('NotEmpty', NotEmpty);
				console.log('that.list', that.list);
				if(!NotEmpty){
					that.SetAnswer(Answer);
				}else{
					that.$util.showError('有未完成的题目，请完成后提交');
				}
			},
			SetAnswer(Answer) {
				var that = this;
				that.isJiaIng = true;
				that.drawLineB(10);
				var form = {
					EvaluationId: that.id,
					Key: that.key,
					Question: Answer
				};
				that.$newapi.HtppRequest(
					'evaluation/SaveUserEvaluation',
					'POST',
					form,
					function(res) {
						console.log('提交', res);
						if (res.code === 0) {
							that.drawLineB(100);
							setTimeout(() => {
								that.isJiaIng = false;
								setTimeout(() => {
									that.drawLineB(0);
									that.$message.success('提交成功');
									setTimeout(() => {
										that.$router.push('/report');
									}, 1500);
								}, 300);
							}, 500);
						} else {
							that.$message.error(res.msg);
							that.isJiaIng = false;
						}
					},
					function(err) {
						console.log(err);
					});
			},
			changeInput(index, ind) {
				var that = this;
				console.log('index', index)
				console.log('ind', ind)
				var obj = that.list[index];
				console.log(obj)
				if (obj.Type === 1) {
					obj.AnswerList.forEach(a => {
						a.isSelect = false;
					});
					console.log('清空', obj.AnswerList);
				} 
				obj.AnswerList[ind].isSelect = true;
				that.list[index] = obj;
				that.$forceUpdate()
				console.log(that.list);
			},
			GetEvaluationQuestion() {
				var that = this;
				that.$newapi.HtppRequest(
					'evaluation/GetEvaluationQuestion?id=' + that.id + '&key=' + that.key,
					'GET', {},
					function(res) {
						console.log('获取做题列表', res);
						if (res.code === 0) {
							var list = res.data;
							if (list && list.length) {
								list = list.map(a => {
									a.NotEmpty = false;
									a.AnswerList.map(b => {
										b.isSelect = false;
									});
									return a;
								});
							}
							that.list = list;
							that.Totla = that.list.length;
						}
					},
					function(err) {
						console.log(err);
					});
			}
		}
	};
</script>

<style scoped>
	.empty-question {
		color: #ff1e00 !important;
		font-weight: bold;
	}

	.gaokao-nav {
		width: 100%;
		display: flex;
		align-items: center;
		padding: 20px 0;
	}

	.gaokao-nav span {
		font-size: 15px;
		color: #333;
	}

	.gaokao-nav span:last-child {
		color: #333;
	}

	/* gaokao-content */
	.gaokao-content {
		padding: 0 20px;
		width: 100%;
		height: auto;
		overflow: hidden;
		background-color: #fff;
		margin-bottom: 25px;
	}

	.test-tit {
		font-size: 16px;
		color: #333;
		position: relative;
		padding-left: 20px;
		margin-bottom: 30px;
	}

	.test-tit::after {
		position: absolute;
		content: '';
		width: 0;
		height: 20px;
		left: 0;
		top: 50%;
		margin-top: -10px;
		border: 2px solid #333;
		border-radius: 50px;
	}

	/* testTwo-con */
	.testTwo-con {
		width: 100%;
		height: auto;
		overflow: hidden;
		padding-top: 20px;
	}

	.testTwo-list {
		width: 100%;
		height: auto;
		overflow: hidden;
	}

	.test-ctxt {
		font-size: 15px;
		color: #333;
		margin-bottom: 25px;
	}

	.testTwo-ul {
		padding: 0 30px;
		height: auto;
		overflow: hidden;
	}

	.testTwo-ul li {
		width: 100%;
		display: flex;
		align-items: center;
		margin-bottom: 25px;
	}

	.testTwo-ul li input {
		margin-right: 15px;
	}

	.testTwo-ul li p {
		font-size: 15px;
		color: #333;
	}

	.test-btn {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.test-btn button {
		margin-left: 20px;
		margin-right: 20px;
	}
</style>
